import axios from "axios";
import { endpoints } from "config/api";
import { getAuthToken } from "utils/helper";

export const getAllCategory = async () => {
  let request = await axios({
    method: "GET",
    url: endpoints.product.GET_ALL_CATEGORY,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

export const addProduct = async (params, data) => {
  let request = await axios({
    method: "POST",
    url: `${endpoints.product.ADD_PRODUCT}`,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params,
    data: data,
  });
  return request;
};
